<template>
  <a-tabs v-model:activeKey="activeKey" @tabClick="tabClick">
    <a-tab-pane key="1" tab="通道广告" :disabled="loading">
      <channel-index :accountId="accountId" :is-refresh="isRefresh" :activeKey="activeKey"></channel-index>
    </a-tab-pane>
    <a-tab-pane key="2" tab="通道账号" :disabled="loading">
      <channel-acc @switchTab="handleSwitchTab" :is-refresh="isRefresh"></channel-acc>
    </a-tab-pane>
    <a-tab-pane key="3" tab="通道域名" :disabled="loading">
      <channel-domain :is-refresh="isRefresh"></channel-domain>
    </a-tab-pane>
  </a-tabs>
  <!-- <div v-if="activeKey === '1'">
    <channel-index></channel-index>
  </div>
  <div v-if="activeKey === '2'">
    <channel-acc></channel-acc>
  </div>
  <div v-if="activeKey === '3'">
    <channel-domain></channel-domain>
  </div> -->
  <!-- <component :is="tabComponent"></component> -->
</template>
<script setup lang="ts">
import { ref, computed } from "vue";
import ChannelIndex from "./components/ChannelIndex.vue";
import ChannelAcc from "./components/ChannelAcc.vue";
import ChannelDomain from "./components/ChannelDomain.vue";

const activeKey = ref("1");
const loading = ref(false);
const accountId = ref("");
const props = defineProps({
  isRefresh: {
    type: Boolean,
    default: false,
  },
});

const tabClick = (key: string) => {
  activeKey.value = key;
};
const handleSwitchTab = (id: string) => {
  activeKey.value = "1";
  accountId.value = id;
};
const tabComponent = computed(() => {
  if (activeKey.value === "1") return ChannelIndex;
  if (activeKey.value === "2") return ChannelAcc;
  if (activeKey.value === "3") return ChannelDomain;
  return ChannelIndex; // fallback
});
</script>
